import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { VFlex } from '@/components/base';
import { modalStyle } from '@/styles/style';

import Body from './Body';
import Header from './Header';

type FeedbackStaticModalProps = {
  children: React.ReactNode;
  style?: CSSProperties;
};

const FeedbackStaticModal = (props: FeedbackStaticModalProps) => {
  return <StyledModal style={props.style}>{props.children}</StyledModal>;
};

FeedbackStaticModal.Header = Header;
FeedbackStaticModal.Body = Body;

const StyledModal = styled(VFlex)`
  position: fixed;
  width: 600px;
  ${modalStyle};
  backdrop-filter: ${(props) =>
    props.theme.colorTheme ? 'blur(12px)' : 'unset'};
`;

export default FeedbackStaticModal;
